module.exports = __webpack_public_path__ + "inclement-weather-bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./theme/bananar/assets/inclement-weather-bg.jpg
// module id = 205
// module chunks = 0 1